import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../../config/apiClients";
import { BankAccountMappingState } from "../../../types";
import { BankAccountMapping } from "../../../../utils/types";

const initialState: BankAccountMappingState = {
  isLoading: false,
  neoBankAccounts: [],
  bankAccountmappings: [],
};

export const getNeoBankAccounts = createAsyncThunk(
  "/neo/v2/bankAccountMapping/getAllNeoBanksAccount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("neo/v2/bankAccountMapping/getAllNeoBanksAccount");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Neo Bank Accounts' });
    }
  }
);

export const createBankAccountMapping = createAsyncThunk(
  "/neo/v2/bankAccountMapping/getAllBankAccountMapping",
  async (bankAccountMapping: BankAccountMapping, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post("neo/v2/bankAccountMapping/create", bankAccountMapping);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to create Bank Account Mapping' });
    }
  }
);

export const updateBankAccountMapping = createAsyncThunk(
  "/neo/v2/bankAccountMapping/update",
  async (bankAccountMapping: BankAccountMapping, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch("neo/v2/bankAccountMapping/update", { ...bankAccountMapping, id: bankAccountMapping._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to update Bank Account Mapping' });
    }
  }
);

export const deleteBankAccountMapping = createAsyncThunk(
  "/neo/v2/bankAccountMapping/delete",
  async (bankAccountMappingId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete("neo/v2/bankAccountMapping/delete", { data: { bankAccountMappingId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to delete Bank Account Mapping' });
    }
  }
);

export const getAllBankAccountMapping = createAsyncThunk(
  "/neo/v2/bankAccountMappingId/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("neo/v2/bankAccountMapping/getAll");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Bank Account Mapping' });
    }
  }
);

const bankAccountMappingSlice = createSlice({
  name: "bankAccountMapping",
  initialState,
  reducers: {
    removeBankAccountMapping: (state, action) => {
      const id = action.payload;
      state.bankAccountmappings = state.bankAccountmappings.filter((item) => item._id !== id);
    },
    resetBankAccountMappingState: (state) => {
      state.isLoading = false;
      state.bankAccountmappings = [];
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getNeoBankAccounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNeoBankAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.neoBankAccounts = action.payload.payload.kAllNeoBankAccounts;
      })
      .addCase(getNeoBankAccounts.rejected, (state) => {
        state.isLoading = false;
        state.neoBankAccounts = [];
      })
      .addCase(getAllBankAccountMapping.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBankAccountMapping.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bankAccountmappings = action.payload.payload.allBankAccountMappings;
      })
      .addCase(getAllBankAccountMapping.rejected, (state) => {
        state.isLoading = false;
        state.bankAccountmappings = [];
      });
  }
})

export const { resetBankAccountMappingState, removeBankAccountMapping } = bankAccountMappingSlice.actions;

export default bankAccountMappingSlice.reducer;